<p style="text-align: center" *ngIf="isInvalidConnection">Invalid connection: {{ connection }}</p>
